<template>
        <b-modal v-model="openModal" :title="'Full Twitter Report for #' + hashtag" :backdrop="false">
            <section v-if="!showPayDeposit && !showPayReport">
                <div class="alert alert-danger alert-dismissible">
                    Twitter discontinued API required by hashtag reports. We currently cannot calculate new hashtag reports.
                    All your existing reports are still available.
<!--                    <input type="date" class="form-control" v-model="fromDate" :min="min" :max="max">-->
<!--                    - -->
<!--                    <input type="date" class="form-control" v-model="toDate" :min="min" :max="max">-->
<!--                    <button @click="calc" class="btn btn-primary"><i v-if="loading" class="fa fa-spin fa-spinner"></i> Calculate price</button>-->
                </div>
<!--                <br v-if="error">-->
<!--                <div v-if="error" class="alert alert-warning alert-dismissible" role="alert">-->
<!--                    <button type="button" class="close" @click="error=false" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
<!--                    {{error}}-->
<!--                </div>-->
<!--                <br>-->
<!--                <div v-if="price && !highlyUsed && !deposit">-->
<!--                    <p><strong>Price of full report</strong></p>-->
<!--                    <p><span class="price">${{price | round(2)}}</span></p>-->
<!--                    <p v-if="false"><input type="checkbox" id="agreement" name="agreement"> <label for="agreement"> I am aware that no refunds are possible after calculating the report</label></p>-->
<!--                </div>-->
<!--                <div v-else-if="price && highlyUsed && !deposit">-->
<!--                    <div class="alert alert-warning">-->
<!--                        <h4>Too many tweets to calculate the price for free</h4>-->
<!--                        <p>Twitter paid API has to be used to calculate the price of such a large report.<br>You have two options:</p>-->
<!--                        <ol>-->
<!--                            <li><strong>Try a shorter range of dates</strong> to lower the number of tweets in the report.</li>-->
<!--                            <li><strong>Pay a refundable deposit</strong>. The amount will be deducted from your first order of any RiteTag report. The price of a report usually ranges from $29 to $99.</li>-->
<!--                        </ol>-->
<!--                    </div>-->
<!--                    <p><span class="price">$29</span> deposit</p>-->
<!--                </div>-->
<!--                <div v-else-if="deposit">-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-8">-->
<!--                            <table class="table">-->
<!--                                <tr>-->
<!--                                    <td>Price of full report</td>-->
<!--                                    <td class="text-right"><strong class="text-success">${{price | round()}}</strong></td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td>Deposit</td>-->
<!--                                    <td class="text-right"><strong>- ${{deposit| round()}}</strong></td>-->
<!--                                </tr>-->
<!--                                <tr class="total">-->
<!--                                    <td><strong>To pay</strong></td>-->
<!--                                    <td class="text-right"><span class="price">${{price - deposit | round()}}</span></td>-->
<!--                                </tr>-->
<!--                            </table>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </section>
            <Payment v-if="showPayDeposit" :hashtag="hashtag" type="deposit" :price="29" :callback="paidDeposit" ref="deposit"/>
            <Payment v-if="showPayReport" :hashtag="hashtag" type="report" :query="query" :price="(price - deposit)" :callback="paidReport" ref="report"/>
            <div slot="footer">
<!--                <button v-if="(price && !highlyUsed || price && deposit) && !showPayReport" class="btn btn-upgrade" @click="buy">Buy full report</button>-->
<!--                <button v-if="!showPayDeposit && price && highlyUsed && !deposit" class="btn btn-upgrade" @click="payDeposit">Pay deposit & calculate exact price</button>-->
                <button class="btn btn-default" @click="close">Cancel</button>
            </div>

        </b-modal>
</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'
    import axios from 'axios'
    import Payment from './Payment'

    export default {
        name: 'price-modal',
        components: {
            Payment
        },
        props: {
            hashtag: {
                default: '',
                type: String
            }
        },
        data () {
            return {
                max: moment.utc().subtract(1, 'days').format('YYYY-MM-DD'),
                min: moment.utc().subtract(30, 'days').format('YYYY-MM-DD'),
                toDate: moment.utc().subtract(1, 'days').format('YYYY-MM-DD'),
                fromDate: moment.utc().subtract(30, 'days').format('YYYY-MM-DD'),
                price: false,
                openModal: false,
                highlyUsed: false,
                deposit: false,
                loading: false,
                showPayDeposit: false,
                showPayReport: false,
                query: {},
                error: false
            }
        },
        methods: {
            close () {
                this.openModal = false
                this.price = false
                this.highlyUsed = false
                this.loading = false
                this.showPayDeposit = false
                this.showPayReport = false
                this.error = false
            },
            open () {
                this.openModal = true
            },
            calc () {
                this.loading = true
                axios.get('/api/v2/report/calculate/' + this.hashtag, {
                    params: {
                        from: this.fromDate,
                        to: this.toDate
                    }
                }).then(resp => {
                    this.loading = false
                    const data = resp.data
                    this.price = data.price
                    this.highlyUsed = data.highlyUsed
                    this.deposit = data.deposit
                }).catch(err => {
                    this.loading = false
                    this.error = err.response.data.message
                    // this.$b_notify({
                    //     type: 'error',
                    //     content: err.response.data.message
                    // })
                })
            },
            checkDeposit () {
                const promise = axios.get('/api/v2/report/deposit')
                promise.then(resp => {
                    this.deposit = resp.data.deposit
                })
                return promise
            },
            payDeposit () {
                this.showPayDeposit = true
                Vue.nextTick().then(() => {
                    this.$refs.deposit.show()
                })
            },
            paidDeposit (data) {
                if (data.result) {
                    this.showPayDeposit = false
                }
                this.checkDeposit()
                this.calc()
            },
            buy () {
                this.query = {
                    hashtag: this.hashtag,
                    from: this.fromDate,
                    to: this.toDate
                }
                this.showPayReport = true
                Vue.nextTick().then(() => {
                    this.$refs.report.show()
                })
            },
            paidReport (data) {
                if (data.result) {
                    const url = '/hashtag-reports/'
                    window.location = url
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .datetime {
        width: 200px;
        display: inline-block;
    }
    .warning {
        padding: 4px 6px;
    }
    .table-price {
        width: 40%;

        .total-price {
            border-top: 1px solid black;
        }
        td:last-child {
            text-align: right;
        }
    }
    ol {
        padding-left: 16px;
        margin-top: 10px;
    }
    .price {
    font-size: 4em;
    color: #5ABD54;
    line-height: 1;
    margin-bottom: 10px;
    display: inline-block;
    }
    label {
        font-weight: normal;
    }
    tr.total {
        border-top: 1px silver solid;
    }
</style>



// WEBPACK FOOTER //
// src/components/PriceModal.vue